import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown'; // ✅ Use Dropdown instead of MultiSelect
import { useEffect, useState } from 'react';
import LocalDelimitationNational from './LocalDelimitationNational';
import MultiFilterTable from './MultiFilterTable';
import { votersService } from '../services/VotersService';
import { Button } from 'primereact/button';
import { APP_TYPE } from '../config/Config';





export default function MultiFilterSearch({ includeEligible = false, label = "Filter By", onChange = () => { }, onClear = () => { }, onStateChange = () => { } }) {
    const [delimitation, setDelimitation] = useState({ delimitationID: "", delimitationLevelID: "" });
    var [options, setOptions] = useState([
        { name: 'ID Number', id: 1 },
        { name: 'Registration Number', id: 2 },
        { name: 'Name & Surname', id: 3 },
        { name: 'Demarcation', id: 4 },
    ]);


    function removeIDNumber(id) {
        return options.filter(e => e.id !== id)
    }

    const [filter, setFilter] = useState(options[0]); // ✅ Single selection
    const [filterTexts, setFilterTexts] = useState({
        [options[0].id]: ""
    });


    useEffect(() => {
        switch (APP_TYPE) {
            case 'PoliticalParty':
            case 'Candidate':
                {
                    var op = removeIDNumber(1)
                    setOptions(op)
                    setFilterTexts(op[0].id)
                    setFilter(op[0])
                }
        }
    }, [])



    const [filterParams, setFilterParams] = useState({});
    const [hideComponent, setHideComponent] = useState(false);



    useEffect(() => {
        if (!hideComponent) {
            try {
                onClear()
            } catch (error) {

            }
        }
        onStateChange(hideComponent)
    }, [hideComponent])

    function checkValue(val) {
        return ["", null, undefined, " ", NaN].includes(val);
    }

    const handleTextChange = (id, value) => {
        setFilterTexts(prev => ({ ...prev, [id]: value }));
    };

    const handleApplyFilter = (e) => {
        const { delimitationID, delimitationLevelID } = e;
        const newParams = {};
        newParams["has_id_number"] = false;
        if (filter) {
            const val = filterTexts[filter.id];
            var id = filter.id
            if (!checkValue(val)) {
                if (id === 1) {
                    newParams["idNumber"] = val;
                    newParams["IDNumber"] = val;

                    newParams["has_id_number"] = false;
                }
                if (id === 2) {
                    newParams["RegistrationNumber"] = val;
                }
                if (id === 3) {
                    newParams["Name"] = val;
                }
            }
        }

        if (!checkValue(delimitationID)) {
            newParams.DelimitationID = delimitationID;
        }
        if (!checkValue(delimitationLevelID)) {
            newParams.DelimitationLevelID = delimitationLevelID;
        }
        setDelimitation({ ...newParams })
        setFilterParams(newParams);
        console.log("Applied Filter Params:", newParams);
    };

    const handleClear = () => {
        setFilterParams({});
    };

    return (

        <>
            {
                (<div className='px-3 pt-3 card' style={{ borderTop: "1px solid #d3d3d3", borderBottom: "1px solid #d3d3d3", backgroundColor: "#f9f9f9", boxShadow: "-13px 20px 5px rgb(0 0 0 / 0%) !important" }}>
                    <div className="grid">
                        <div className="col-12">
                            <label ><b className='py-2'>{label}</b></label><br />
                            <div style={{ display: "flex", "alignItems": "center", justifyContent: "space-between" }}>

                                <Dropdown
                                    disabled={hideComponent}
                                    value={filter}
                                    onChange={(e) => {
                                        setFilter(e.value);
                                        const updatedTexts = {};
                                        updatedTexts[e.value.id] = filterTexts[e.value.id] || "";
                                        setFilterTexts(updatedTexts);
                                    }}
                                    options={options}
                                    optionLabel="name"
                                    placeholder="Select a Filter"
                                    style={{ width: !hideComponent ? "100%" : "calc(100% - 80px)" }}
                                />
                                {hideComponent && (<>

                                    <Button
                                        // disabled={isOnlyView}
                                        onClick={() => {
                                            setHideComponent(false)
                                        }}
                                        style={{ textAlign: "center", width: "30px", height: "30px", margin: "0px 20px" }}
                                        icon={"pi pi-times"}
                                        className="p-button-danger p-button-rounded"
                                    // tooltip="Change"
                                    />


                                </>
                                )}
                            </div>

                        </div>

                        {
                            !hideComponent && (<>
                                {filter && (
                                    <>
                                        {filter.id !== 4 && (<>
                                            <div className='col-12 md:col-4'>
                                                <label className='my-2'>{filter.name} <span style={{ color: "red" }}>*</span></label><br />
                                                <InputText
                                                    className="w-full"
                                                    value={filterTexts[filter.id] || ""}
                                                    onChange={(e) => handleTextChange(filter.id, e.target.value)}
                                                    onKeyDown={e => {
                                                        const isControlKey = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(e.key);
                                                        const isNumber = /[0-9]/.test(e.key);
                                                        if (filter.id !== 3 && !isNumber && !isControlKey) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </>)}
                                    </>

                                )}
                            </>)
                        }


                        {!hideComponent && (<>

                            <div className="col-12">
                                <span style={{ display: "flex", justifyContent: "center", height: "1px", width: "100%", border: "1px solid #d3d3d3" }}></span>
                            </div>
                            <div className="col-12">
                                <LocalDelimitationNational
                                    midGridBlock={4}
                                    councilGridBlock={4}
                                    onClearFilter={handleClear}
                                    onFilter={handleApplyFilter}
                                    bold={false}
                                    isNational={true}
                                    includeVillage={true}
                                    showFilter={true}
                                    hideDropdown={![3, 4].includes(filter.id)}
                                />
                            </div>
                        </>)}



                    </div>
                    {!hideComponent && (<>
                        <MultiFilterTable includeEligible={includeEligible} onChange={onChange} setHideComponent={setHideComponent} key={JSON.stringify(delimitation)} filterParams={filterParams} _delimitation={delimitation} />

                    </>)}

                </div>)
            }
        </>

    );
}
